import React from 'react';
import { Route, Routes } from 'react-router-dom';

import EditProtocolTemplate from "./EditProtocolTemplate";
import ViewProtocolTemplates from "./ViewProtocolTemplates";

const propTypes = {};

const defaultProps = {};

function ProtocolTemplateRouter() {
    return (
        <Routes>
            <Route path="/template/:templateId" element={<EditProtocolTemplate />} />
            <Route index element={<ViewProtocolTemplates />} />
        </Routes>
    );
}

ProtocolTemplateRouter.propTypes = propTypes;
ProtocolTemplateRouter.defaultProps = defaultProps;

export default ProtocolTemplateRouter;
